import React from 'react';
import { theme } from '../../styles/theme';

const Card = ({ 
  children, 
  variant = 'default',
  padding = 'xl',
  shadow = 'md',
  hover = true,
  onClick,
  className = '',
  style = {},
  ...props 
}) => {
  const getCardStyles = () => {
    const baseStyles = {
      backgroundColor: theme.colors.white,
      borderRadius: theme.borderRadius.xl,
      boxShadow: theme.shadows[shadow],
      padding: theme.spacing[padding],
      transition: theme.transitions.normal,
      fontFamily: theme.typography.fontFamily.primary,
      position: 'relative',
      overflow: 'hidden',
    };

    const variants = {
      default: {
        backgroundColor: theme.colors.white,
        border: `1px solid ${theme.colors.gray[200]}`,
      },
      elevated: {
        backgroundColor: theme.colors.white,
        boxShadow: theme.shadows.lg,
      },
      outlined: {
        backgroundColor: 'transparent',
        border: `2px solid ${theme.colors.gray[300]}`,
        boxShadow: 'none',
      },
      primary: {
        backgroundColor: `${theme.colors.primary}05`,
        border: `1px solid ${theme.colors.primary}20`,
      },
    };

    const hoverStyles = hover && onClick ? {
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: theme.shadows.xl,
      },
    } : hover ? {
      '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: theme.shadows.lg,
      },
    } : {};

    return {
      ...baseStyles,
      ...variants[variant],
      ...hoverStyles,
      ...style,
    };
  };

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <div
      style={getCardStyles()}
      onClick={handleClick}
      className={className}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card; 